<template>
  <div class="panel wraper">
    <div class="panel-header" style="margin-right: 50px;">
      <div class="panel-title">
        Поиск по базе
      </div>
    </div>
    <div class="panel-body" @keyup.enter="search">
      <q-field
        :error="$v.query.term.$error"
        :error-label="$v.query.term | errorLabel"
      >
        <q-input float-label="Текст для поиска" v-model.trim="query.term" :autofocus="true" />
      </q-field>
      <q-field
          orientation="vertical"
          label="Область поиска"
          :error="$v.query.where.$error"
          error-label="Выберите хотя бы один вариант"
      >
        <q-option-group class="q-mb-sm"
            type="radio"
            color="primary"
            v-model="query.where"
            :options="[
            { label: 'Клиенты', value: 'h' },
            { label: 'Подразделения', value: 'd' },
            { label: 'Приборы', value: 'i' },
            { label: 'Персоны', value: 'p' },
            { label: 'Кейсы', value: 'c' },
            { label: 'Телефоны', value: 't' },
            { label: 'Серийные №', value: 's' },
            { label: 'Вложения', value: 'm' },
          ]"
        />
      </q-field>
    </div>
    <transition name="top" appear>
      <q-page-sticky position="top-right" :offset="[18, 18]">
        <q-btn round small color="primary" @click="search" icon="search">
          <q-tooltip self="center right" anchor="center left" :delay="500">Искать</q-tooltip>
        </q-btn>
      </q-page-sticky>
    </transition>
    <q-inner-loading :visible="searching">
      <q-spinner-gears size="100px" color="primary"></q-spinner-gears>
    </q-inner-loading>
  </div>
</template>
<script type="text/babel">
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';

export default {
  name: 'searchForm',
  components: {
  },
  data() {
    return {
      searching: false,
      query: {
        term: this.$store.state.searchQuery.term,
        where: this.$store.state.searchQuery.where,
      },
    };
  },
  validations: {
    query: {
      term: {
        required: withParams({ message: 'Введите текст для поиска' }, required),
        minLength: withParams({ message: 'От 2 до 40 символов' }, minLength(2)),
        maxLength: withParams({ message: 'От 2 до 40 символов' }, maxLength(40)),
      },
      where: {
        required,
      },
    },

  },
  computed: {
    _query() {
      return {
        term: this.$store.state.searchQuery.term,
        where: this.$store.state.searchQuery.where,
      };
    },
  },
  watch: {
    _query: {
      handler(value) {
        this.query.term = value.term;
        this.query.where = value.where;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    document.title = 'Поиск';
  },
  methods: {
    search() {
      const self = this;
      this.$v.query.$touch();
      if (this.$v.query.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      this.searching = true;
      console.log('start', self.searching);
      this.$store.dispatch('doQuickSearch', { term: this.query.term, where: this.query.where })
        .then((found) => {
          console.log('SEARCHFORM then');
          self.searching = false;
          if (found) {
            self.$router.push('/found');
          }
        })
        .catch((err) => {
          console.log('SEARCHFORM error', err);
          self.searching = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/search-form.vue